import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import { colors } from '../../lib/styles';
import Icon from '../ui/icon/icon';
import './styles.css';

const styles = {
    label: {
        color: colors.link,
        textTransform: 'uppercase',
        fontSize: 14,
        marginLeft: -9,
        fontWeight: 500,
    },
};

type Props = {
    onClick: ?Function,
}

class ShowHiddenElement extends React.Component<Props> {
    render() {
        return (
            <Checkbox
                checkedIcon={<Icon icon="checkbox" id="hidden-toggle" style={{ padding: 3 }} />}
                className="show-hidden"
                label="Показать скрытые"
                labelStyle={styles.label}
                iconStyle={{ fill: colors.link }}
                onCheck={(e, isInputChecked) => {
                    document.getElementById('hidden-toggle').style.opacity = +isInputChecked;
                    document.getElementById('hidden-toggle').style.transform = `scale(${+isInputChecked})`;
                    if (this.props.onClick) {
                        this.props.onClick(isInputChecked);
                    }
                }}
            />
        );
    }
}

export default ShowHiddenElement;



// WEBPACK FOOTER //
// src/components/showHiddenElement/index.js